define(function(require, exports, module) {
    'use strict';

    const i18n = require('i18n');
    const tmpl = require('tmpl');
    const Form = require('class/form.class');

    Form.prototype.showErrorMessage = function(message = {}, errorCode) {
        this.$el.find('.fn-form-messages').html(tmpl['common.messages']({
            className: message.className || `error ${errorCode ? `custom-message error-${errorCode}` : 'error'}`,
            errorCode: errorCode,
            content: i18n.tExt(message.translation, message.content) || i18n.tExt('playtech.mobile.system.systemError', 'System error')
        }));

        return this;
    };

    module.exports = Form;
});
